/* WEAVEPLACE — unified local wishlist, no account or external app required. */
(()=>{
 'use strict';
 if(window.WEAVEPLACEWishlist)return;
 const KEY='weaveplace-wishlist-v1';
 // Old independent wishlist keys must never repopulate removed favorites.
 const retiredKeys=['weaveplace-plp-favorites','wp-pdp-wishlist-products','weaveplace-wishlist'];
 const normalizedHandle=value=>{if(!value)return '';try{const path=new URL(value,location.origin).pathname;return decodeURIComponent((path.match(/\/products\/([^/]+)/)||[])[1]||'');}catch{return ''}};
 let items=[];
 try{const a=JSON.parse(localStorage.getItem(KEY)||'[]');if(Array.isArray(a))items=a.filter(p=>p&&p.handle&&p.id).map(p=>({id:String(p.id),handle:p.handle}));}catch{}
 const save=()=>{try{localStorage.setItem(KEY,JSON.stringify(items));}catch{}window.dispatchEvent(new CustomEvent('weaveplace:wishlist-change',{detail:{items:items.slice()}}));sync();};
 const has=id=>items.some(p=>p.id===String(id));
 const add=(id,handle)=>{id=String(id||'');handle=normalizedHandle(handle)||handle;if(!id||!handle)return false;if(!has(id)){items.push({id,handle});save();}return true};
 const remove=id=>{items=items.filter(p=>p.id!==String(id));save()};
 const toggle=(id,handle)=>{if(has(id)){remove(id);return false;}return add(id,handle)};
 const findButton=button=>{
   if(button.hasAttribute('data-wp-cart-wish'))return {id:String(button.dataset.productId||''),handle:String(button.dataset.productHandle||'')};
   const card=button.closest('wp-product-card');
   const pdp=button.closest('weaveplace-product');
   const id=button.dataset.productIdNumeric||pdp?.querySelector('[data-wp-wishlist]')?.dataset.productId||card?.dataset.productId||button.dataset.wpFavorite||'';
   const handle=button.dataset.productHandle||card?.dataset.handle||normalizedHandle(pdp?.dataset.productUrl)||normalizedHandle(card?.querySelector('a[href*="/products/"]')?.href)||normalizedHandle(button.dataset.productId);
   return {id:String(id),handle};
 };
 // The unified store is the only source of truth. Clear retired snapshots so
 // navigating to another page cannot resurrect items already removed here.
 for(const key of retiredKeys){try{localStorage.removeItem(key);}catch{}}
 const BUTTONS='[data-wpc-favorite],[data-wp-wishlist],[data-wp-favorite],[data-wp-cart-wish]';
 const setButtonState=button=>{
   const item=findButton(button),active=has(item.id);
   const pressed=String(active),label=active?'Favorilerden çıkar':'Favorilere ekle';
   if(button.getAttribute('aria-pressed')!==pressed)button.setAttribute('aria-pressed',pressed);
   if(button.getAttribute('aria-label')!==label)button.setAttribute('aria-label',label);
   if(button.hasAttribute('data-wp-wishlist'))button.classList.toggle('is-saved',active);
   if(button.hasAttribute('data-wp-favorite'))button.classList.toggle('is-active',active);
   if(button.hasAttribute('data-wp-cart-wish'))button.classList.toggle('is-saved',active);
 };
 function sync(){
   document.querySelectorAll(BUTTONS).forEach(setButtonState);
   document.querySelectorAll('[data-wp-wishlist-count]').forEach(n=>{const next=String(items.length);if(n.textContent!==next)n.textContent=next;});
   document.querySelectorAll('[data-wp-wishlist-counter]').forEach(n=>{const hidden=items.length===0;if(n.hidden!==hidden)n.hidden=hidden;});
   document.querySelectorAll('[data-wp-wishlist-count-label]').forEach(n=>{const next=items.length+' favori ürün';if(n.textContent!==next)n.textContent=next;});
 }
 // Capture before legacy delegated card listeners; avoid double toggling.
 document.addEventListener('click',event=>{
   const button=event.target.closest?.(BUTTONS);
   if(!button)return;
   const item=findButton(button);
   if(!item.id||!item.handle)return; // Retain existing behavior if markup has no usable handle.
   event.preventDefault();event.stopImmediatePropagation();
   toggle(item.id,item.handle);
 },true);
 document.addEventListener('DOMContentLoaded',sync);
 if(document.readyState!=='loading')sync();
 window.addEventListener('storage',e=>{if(e.key!==KEY)return;try{items=JSON.parse(e.newValue||'[]')||[];}catch{items=[];}sync();window.dispatchEvent(new Event('weaveplace:wishlist-change'));});
 // Shopify AJAX sections may insert product cards after the initial page load.
 // Only sync newly inserted wishlist buttons, not every DOM change.
 const addedButtons=new Set();
 let scheduled=false;
 const flushAdded=()=>{
   scheduled=false;
   if(!addedButtons.size)return;
   const buttons=Array.from(addedButtons);
   addedButtons.clear();
   buttons.forEach(setButtonState);
 };
 const observer=new MutationObserver(records=>{
   for(const record of records){
     for(const node of record.addedNodes){
       if(node.nodeType!==1)continue;
       if(node.matches?.(BUTTONS))addedButtons.add(node);
       node.querySelectorAll?.(BUTTONS).forEach(button=>addedButtons.add(button));
     }
   }
   if(addedButtons.size&&!scheduled){
     scheduled=true;
     Promise.resolve().then(flushAdded);
   }
 });
 const startObserving=()=>{if(document.body)observer.observe(document.body,{subtree:true,childList:true});};
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',startObserving,{once:true});
 else startObserving();
 window.WEAVEPLACEWishlist={all:()=>items.slice(),has,add,remove,toggle,sync};
})();
